import { render, staticRenderFns } from "./popover.vue?vue&type=template&id=574f34d7&scoped=true"
import script from "./popover.vue?vue&type=script&lang=js"
export * from "./popover.vue?vue&type=script&lang=js"
import style0 from "./popover.vue?vue&type=style&index=0&id=574f34d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574f34d7",
  null
  
)

export default component.exports